import React from 'react';
import SaveIconButton from '../../../../ui-components/Button/SaveIconButton';
// import DeleteButton from '../../../../ui-components/Button/DeleteButton';
import DeleteIconButton from '../../../../ui-components/Button/DeleteIconButton'
import { withStyles, StyledComponentProps } from '@material-ui/core';
import NewItemButton from '../../../../ui-components/Button/NewItemButton';

interface IProps extends StyledComponentProps {
    disabled: boolean;
    exist: boolean;
    save: () => any;
    delete: () => any;
}
const styles = {
    container: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '10px',
        width: '100%'
    }
}
const Comp = (props: IProps) => {
    return (<div className={props.classes.container}>
        {props.exist ? <SaveIconButton onClick={props.save} disabled={props.disabled}/> : <NewItemButton onClick={props.save} text=""  disabled={props.disabled}/>}
        {props.exist && <DeleteIconButton onClick={props.delete} disabled={props.disabled} />}
    </div>)
}

export const Buttons = withStyles(styles)(Comp) 